// extracted by mini-css-extract-plugin
module.exports = {"container":"SkeletonUserCardsList_container__20qsZ","card":"SkeletonUserCardsList_card__2IUNG"};